export const PRICING_SECTION_ID = 'pricing'

/** Ancre scroll vers l'encart essai gratuit (bannière FreeTier). */
export const FREE_TRIAL_SECTION_ID = 'free-trial'

/** Ancre scroll + onglet Dendromap (forfait Basic). */
export const PRICING_HASH_DENDROMAP = 'pricing-dendromap'

/** Ancre scroll + onglet Dendromap Advanced+. */
export const PRICING_HASH_ADVANCED = 'pricing-advanced'

export const DENDROCARE_SITE_URL = 'https://dendrocare.fr'

export type PricingTabValue = 'basic' | 'advanced'

type PricingTabNavigateHandler = (tab: PricingTabValue) => void

let pricingTabNavigateHandler: PricingTabNavigateHandler | null = null

/** Enregistre le callback React (PricingSection) pour appliquer l’onglet sans attendre hashchange. */
export function registerPricingTabNavigate(handler: PricingTabNavigateHandler | null): void {
  pricingTabNavigateHandler = handler
}

export function getPricingHref(tab: PricingTabValue): string {
  return tab === 'advanced' ? `#${PRICING_HASH_ADVANCED}` : `#${PRICING_HASH_DENDROMAP}`
}

export function resolvePricingTabFromHash(hash: string): PricingTabValue | null {
  if (hash === `#${PRICING_HASH_ADVANCED}`) {
    return 'advanced'
  }
  if (hash === `#${PRICING_HASH_DENDROMAP}` || hash === `#${PRICING_SECTION_ID}`) {
    return 'basic'
  }
  return null
}

export function scrollToPricingSection(behavior: ScrollBehavior = 'smooth'): void {
  document.getElementById(PRICING_SECTION_ID)?.scrollIntoView({ behavior, block: 'start' })
}

export function scrollToFreeTrialSection(behavior: ScrollBehavior = 'smooth'): void {
  document.getElementById(FREE_TRIAL_SECTION_ID)?.scrollIntoView({ behavior, block: 'start' })
}

export function getFreeTrialHref(): string {
  return `#${FREE_TRIAL_SECTION_ID}`
}

/** Ouvre l’onglet tarif voulu et fait défiler jusqu’à la section `#pricing`. */
export function navigateToPricingTab(tab: PricingTabValue): void {
  const nextHash = getPricingHref(tab)

  pricingTabNavigateHandler?.(tab)

  if (window.location.hash !== nextHash) {
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${nextHash}`)
  }

  requestAnimationFrame(() => {
    scrollToPricingSection()
  })
}
